<template>
  <div class="widget">
    <v-container fill-height>
      <v-layout
        align-center
        fill-height>
        <v-flex shrink>
          <v-layout align-center>
            <v-icon large>dashboard</v-icon>
            <span class="ml-2 title">Layout</span>
          </v-layout>
        </v-flex>
        <v-spacer/>
        <v-flex shrink>
          <v-btn
            :disabled="layoutUnchanged"
            icon
            @click="save">
            <v-icon>save</v-icon>
          </v-btn>
        </v-flex>
        <v-flex shrink>
          <v-btn
            :disabled="userLayout.length + newLayout.length === 0"
            icon
            @click="restore">
            <v-icon>settings_backup_restore</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "layout",
  props: {
    email: {
      required: true,
      type: String
    },
    newLayout: {
      required: true,
      type: Array
    },
    userLayout: {
      required: true,
      type: Array
    }
  },
  data () {
    return { layoutUnchanged: true };
  },
  watch: {
    newLayout () {
      this.layoutUnchanged = false;
    }
  },
  methods: {
    restore () {
      this.$http.
        put(`/api/users/${this.email}`, { layout: null }).
        then(() => this.$emit("refresh"));
    },
    save () {
      this.$http.
        put(`/api/users/${this.email}`, { layout: this.newLayout }).
        then(() => this.$emit("refresh"));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Site/Layout.vue